<div class="input-group typeahead typeahead-cliente">
    <ng-template #typeaheadTemplate let-item="item">
        <span>{{item.pessoa.codigoIntegracaoErp}} - {{item.pessoa.nome}}</span> 
        <small class="typeahead-cliente-cnpj-cpf">{{item.pessoa.nomeFantasia}} - {{item.pessoa.cnpjCpf}} - {{item.nomeCidade}} - {{item.uf}}</small>    
        <small *ngIf="!isRepresentante" class="typeahead-cliente-cnpj-cpf">{{item.codigoIntegracaoErpRepresentante}} - {{item.nomeRepresentante}}</small>            

        <span *ngIf="!isClienteCadastroCliente(item.cadastro)" class="{{item.cadastro | clienteCadastroBadge}} badge-cadastro">{{item.cadastro | clienteCadastro}}</span>
        <span *ngIf="!isClienteSituacaoAtivo(item.situacao)" class="{{item.situacao | clienteSituacaoBadge}} badge-situacao">{{item.situacao | clienteSituacao}}</span>
    </ng-template>
            
    <div class="input-group-prepend">
        <span class="input-group-text">{{entity?.pessoa?.codigoIntegracaoErp}}</span>
    </div> 
    <input 
        type="text"
        class="form-control"
        #inputTypeahead

        [typeahead]="typeaheadDataSource"
        [typeaheadWaitMs]="300"
        [typeaheadItemTemplate]="typeaheadTemplate"
        typeaheadOptionField="pessoa.nome"
        [typeaheadMinLength]="2"
        [typeaheadOptionsLimit]="typeaheadOptionsLimit"
        [typeaheadScrollable]="true"
        [typeaheadOptionsInScrollableView]="typeaheadOptionsInScrollableView"
        [ngModel]="typeaheadSelected"
        (ngModelChange)="typeaheadToken = $event"
        (typeaheadOnSelect)="onSelectEntity($event)"
        (typeaheadNoResults)="onChangeTypeaheadNoResults($event)"
        (typeaheadLoading)="isLoading = $event"
        [container]="container"
        [dropup]="dropup"

        (keyup)="onKeyup($event)"
        (blur)="onBlur()"
        [class.ng-invalid]="ngControl.invalid"
        [required]="required"
        [disabled]="disabled"
        [readonly]="readonly"
        autocomplete="off"
        placeholder="Digite para pesquisar...">

    <span *ngIf="isLoading">
        <i class="fas fa-spinner fa-pulse loading-indicator"></i>
    </span>

    <div class="input-group-append">
        <button type="button" class="btn btn-light" (click)="clear()" tabindex="-1">
            <i class="fas fa-eraser" aria-hidden="true"></i>
        </button>
    </div>
</div>
<p class="form-text text-muted nome-fantasia-cnpj-cpf" *ngIf="entity && entity.pessoa">
    {{entity.pessoa.nomeFantasia}} - {{entity.pessoa.cnpjCpf}} - {{entity.nomeCidade}} - {{entity.uf}}
    <span *ngIf="!isClienteCadastroCliente(entity.cadastro)" class="{{entity.cadastro | clienteCadastroBadge}}">{{entity.cadastro | clienteCadastro}}</span>
    <span *ngIf="!isClienteSituacaoAtivo(entity.situacao)" class="{{entity.situacao | clienteSituacaoBadge}}">{{entity.situacao | clienteSituacao}}</span>
</p>
<p class="form-text text-muted" *ngIf="typeaheadNoResults === true">Nenhuma central de compras foi encontrada</p>

